import { useAuth } from "../context/AuthContext";

export const useRequireAuth = () => {
  const { user, setAuthOpen } = useAuth();
  return () => {
    if (user) return true;
    setAuthOpen(true);
    return false;
  };
};
